import { render, staticRenderFns } from "./storeEditPage.vue?vue&type=template&id=4fc06b7c&"
import script from "./storeEditPage.vue?vue&type=script&lang=ts&"
export * from "./storeEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports